import req, { createAxios } from './req'
import axios from 'axios'
// 业绩统计接口

// 获取导购业绩统计列表
export function getGuideStatistic (params) {
  return req.get('/statistic/bysalesperson', params)
}

//获取导购业绩统计详情
export function getGuideStatisticInfo (salespersonId, params) {
  return req.get('/salesperson/statistic/' + salespersonId, params)
}

// 获取社群业绩列表
export function getCommunityPerformanceList (params) {
  return req.get('/salesperson/customer-base/performance-list', params)
}

//获取社群业绩统计详情
export function getCommunityInfo (params) {
  return req.get('/salesperson/customer-base/performance-info', params)
}

//导出社群业绩统计
export function createCommunityExportList (params) {
  const donwload = createAxios(axios.create(), false)
  return donwload.post('/salesperson/customer-base/performance-export', params)
}

/*********************************招新报表*******************************************/

// 获取招新-导购列表
export function getRecruitList (params) {
  return req.get('/salesperson/customer-base/recruit-list', params)
}

// 获取招新-导购详情
export function getRecruitInfo (params) {
  return req.get('/salesperson/customer-base/recruit-info', params)
}

/*************************************共有的****************************************/

// 获取生成报表的列表数据
export function getExportList (params) {
  return req.get('/salesperson/statistic/files', params)
}

// 删除生成报表的列表数据
export function deleteExportList (params) {
  return req.post('/salesperson/statistic/files/download-filedelete', params)
}

// 业绩统计-运维维度渠道和导购维度的今日、昨天、和本月数据总计
export function getOverviewStatistic (params) {
  return req.get('/statistic/olives', params)
}
// 获取门店业绩统计列表
export function getStoreStatistic (params) {
  return req.get('/statistic/bystore', params)
}

//客户统计-每日实时数据和总计数据
export function getRealTimeCount (params) {
  return req.get('/members/real-time-count', params)
}

//客户统计-每日总计数据
export function getEveryDayCount (params) {
  return req.get('/members/every-day-count', params)
}

//导出用户UV报表
export function exportReport (params) {
  const donwload = createAxios(axios.create(), false)
  return donwload.post('/salesperson/unique-visito/export', params)
}

// 获取UV报表
export function getUVList (params) {
  return req.get('/salesperson/unique-visito/list', params)
}
